import { radioBenefits } from '@/mocks/radioBenefits';

const iconAccents: Record<number, string> = {
  0: 'bg-rose-50 text-rose-600 group-hover:bg-rose-500 group-hover:text-white',
  1: 'bg-amber-50 text-amber-600 group-hover:bg-amber-500 group-hover:text-white',
  2: 'bg-emerald-50 text-emerald-600 group-hover:bg-emerald-500 group-hover:text-white',
  3: 'bg-sky-50 text-sky-600 group-hover:bg-sky-500 group-hover:text-white',
  4: 'bg-violet-50 text-violet-600 group-hover:bg-violet-500 group-hover:text-white',
  5: 'bg-orange-50 text-orange-600 group-hover:bg-orange-500 group-hover:text-white',
  6: 'bg-teal-50 text-teal-600 group-hover:bg-teal-500 group-hover:text-white',
  7: 'bg-indigo-50 text-indigo-600 group-hover:bg-indigo-500 group-hover:text-white',
  8: 'bg-cyan-50 text-cyan-600 group-hover:bg-cyan-500 group-hover:text-white',
  9: 'bg-fuchsia-50 text-fuchsia-600 group-hover:bg-fuchsia-500 group-hover:text-white',
  10: 'bg-lime-50 text-lime-600 group-hover:bg-lime-500 group-hover:text-white',
  11: 'bg-slate-50 text-slate-600 group-hover:bg-slate-500 group-hover:text-white',
};

export default function BenefitsRadios() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden bg-background-50">
      {/* Ambient glows */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-rose-400/2 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-emerald-400/2 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold mb-5">
            <i className="ri-sparkling-line text-xs"></i>
            Beneficios
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Mucho más que{' '}
            <span className="text-emerald-600">streaming</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            RFW no es solo una plataforma para transmitir. Es el ecosistema completo para que tu radio crezca, compita y se destaque en la comunidad radial más grande.
          </p>
        </div>

        {/* Benefits grid — 4 cols desktop, 3 tablet, 2 small, 1 mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
          {radioBenefits.map((benefit, idx) => (
            <div
              key={benefit.id}
              className="group flex flex-col p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/50 hover:border-background-300/60 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Icon */}
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 transition-all duration-300 ${iconAccents[idx] || 'bg-emerald-50 text-emerald-600 group-hover:bg-emerald-500 group-hover:text-white'}`}>
                <i className={`${benefit.icon} text-lg`}></i>
              </div>

              {/* Title */}
              <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-1.5">
                {benefit.title}
              </h3>

              {/* Description */}
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 text-center">
          <p className="text-xs text-foreground-400">
            Todos los beneficios incluidos desde el plan gratuito. Hosting RFW es opcional.
          </p>
        </div>
      </div>
    </section>
  );
}